<template>
  <div class="animated fadeIn">
    <b-card>
    <p class="h2">プラン変更</p>
    <p> ご利用中のプランを変更することができます。<br>ベーシック、スタンダード、プレミアム、プラチナプランを解約した場合、自動的にライトプランになります。</p>
    <p></p>
      <div class="scroll-box">
        <div class="pricing_table">
        <div class="pricing_box heading radius-left">
            <div class="header"><span></span></div>
            <ul>
            <li class="price">
                <p>料金<span class="notes">※2</span></p>
            </li>
              <li>3Dデータ同時公開数</li>
              <li>3Dデータ保存総数</li>
              <li>白模型・スケルトン</li>
              <li>断面図（水平・垂直）</li>
              <li>太陽光シミュレーション</li>
              <li>画像保存</li>
              <li>スマホVR</li>
              <li>背景編集</li>
              <li>カラーコーディネート</li>
              <li>カラーチェンジ</li>
              <li>建具開閉</li>
              <li>LINE連携</li>
            </ul>
            <p class="space"></p>
        </div>
        <div :class="boxClassNameLight()">
            <div class="header"><span>ライト</span><span class="notes">※1</span></div>
            <ul>
            <li class="price">
                <p>無  料</p>
            </li>
            <li>ライセンス数<span class="notes">※3</span></li>
            <li>ライセンス数<span class="notes">※3</span></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-no.png" width="24px"></li>
              <li><img src="static/img/icon-no.png" width="24px"></li>
              <li><img src="static/img/icon-no.png" width="24px"></li>
              <li><img src="static/img/icon-no.png" width="24px"></li>
            </ul>
            <div class="graybutton" v-if="this.gradetype == 0" disabled>現在ご利用中</div>
            <p class="space" v-else></p>
        </div>
        <div :class="boxClassNameBasic()">
            <div class="header"><span>ベーシック</span><span class="notes">※1</span></div>
            <ul>
            <li class=" price">
                <p>36,000円/年<br>
                <span class="annual"></span></p>
            </li>
            <li class="number">3</li>
            <li class="number">30</li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
            </ul>
            <p></p>
            <div class="graybutton" v-if="this.gradetype == 2" disabled>現在ご利用中</div>
            <p class="button signup" v-else><a href="https://www.cpu-net.co.jp/form/3dplayer_basic.html" target="_blank">プラン変更</a></p>
        </div>
        <div :class="boxClassNameStandard()">
            <div class="header"><span>スタンダード</span><span class="notes">※1</span></div>
            <ul>
            <li class="price">
                <p>60,000円/年<br>
                <span class="annual"></span></p>
            </li>
            <li class="number">10</li>
            <li class="number">100</li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
            </ul>
            <p></p>
            <div class="graybutton" v-if="this.gradetype == 3" disabled>現在ご利用中</div>
            <p class="button signup" v-else><a href="https://www.cpu-net.co.jp/form/3dplayer_standard.html" target="_blank">プラン変更</a></p>
        </div>
        <div :class="boxClassNamePremium()">
            <div class="header"><span>プレミアム</span><span class="notes">※1</span></div>
            <ul>
            <li class="price">
                <p>120,000円/年<br>
                <span class="annual"></span></p>
            </li>
            <li class="number">30</li>
            <li class="number">300</li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
              <li><img src="static/img/icon-yes.png" width="24px"></li>
            </ul>
            <p></p>
            <div class="graybutton" v-if="this.gradetype == 4" disabled>現在ご利用中</div>
            <p class="button signup" v-else><a href="https://www.cpu-net.co.jp/form/3dplayer_premium.html" target="_blank">プラン変更</a></p>
        </div>
        <div :class="boxClassNamePlatinum()">
          <div class="header"><span>プラチナ</span><span class="notes">※1</span></div>
              <ul>
                <li class="price">
                  <p>240,000円/年<br>
                    <span class="annual"></span></p>
                </li>
                <li class="number">100</li>
                <li class="number">1000</li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
                <li><img src="static/img/icon-yes.png" width="24px"></li>
              </ul>
              <p></p>
            <div class="graybutton" v-if="this.gradetype == 5" disabled>現在ご利用中</div>
            <p class="button signup" v-else><a href="https://www.cpu-net.co.jp/form/3dplayer_platinum.html" target="_blank">プラン変更</a></p>
            </div>
        </div>
        <ul class="notes-list">
            <li>※1：いずれのプランもサポート会員への加入が必須となります。</li>
            <li>※2：料金は税別となっております。</li>
            <li>※3：複数ライセンスをお持ちの方は、その分の3Dデータの同時公開数と保存総数をご利用いただけます。</li>
        </ul>
      </div>
    </b-card>
  </div>
</template>

<script>
import Store from '@/store'

export default {
  name: 'tables',
  components: {
    Store
  },
  data () {
    return {
      gradetype: Store.state.gradetype,
      gradeChangeLink: 'https://www.cpu-net.co.jp/cad/3dplayer'
    }
  },
  async created () {
    console.log(this.gradetype)
  },
  methods: {
    boxClassNameLight () {
      if (Number(this.gradetype) === 0) {
        return 'pricing_box light large'
      } else {
        return 'pricing_box light'
      }
    },
    boxClassNameBasic () {
      if (Number(this.gradetype) === 2) {
        return 'pricing_box basic large'
      } else {
        return 'pricing_box basic'
      }
    },
    boxClassNameStandard () {
      if (Number(this.gradetype) === 3) {
        return 'pricing_box standard large'
      } else {
        return 'pricing_box standard'
      }
    },
    boxClassNamePremium () {
      if (Number(this.gradetype) === 4) {
        return 'pricing_box premium large'
      } else {
        return 'pricing_box premium'
      }
    },
    boxClassNamePlatinum () {
      if (Number(this.gradetype) === 5) {
        return 'pricing_box platinum radius-right large'
      } else {
        return 'pricing_box platinum radius-right'
      }
    }
  }
}
</script>

<style scoped>
/*--------------------------------------
比較テーブル
--------------------------------------*/
.scroll-box {
    overflow-y: auto;
}

/*******************************/
/*          シンプル           */
/*******************************/
.stripe_table {
    border-collapse: collapse;
    border-spacing: 0;
    color: #333;
}
.stripe_table th, .stripe_table td {
    padding: .5em 1em;
}
.stripe_table thead th {
    color: #3274B9;
    font-weight: bold;
    text-align: center;
    border-top: 2px solid #3274B9;
    border-bottom: 2px solid #3274B9;
}
.stripe_table tbody th {
    text-align: left;
}
.stripe_table tbody td {
    text-align: center;
}
.stripe_table tbody tr:nth-child(odd) {
    background-color: #dbedff;
}
.stripe_table tbody tr:nth-child(odd) th,
.stripe_table tbody tr:nth-child(odd) td {
    border-right: 1px solid #b7dbff;
}
.stripe_table tbody tr:nth-child(even) {
    background-color: #fff;
}
.stripe_table tbody tr:nth-child(even) th,
.stripe_table tbody tr:nth-child(even) td {
    border-right: 1px solid #eee;
}
.stripe_table tbody tr td:last-child {
    border-right: none;
}

/*******************************/
/*          一部強調           */
/*******************************/
body {font-family: 'メイリオ','Meiryo','Hiragino Kaku Gothic Pro','ヒラギノ角ゴ Pro W3','Osaka','MSゴシック','ＭＳ Ｐゴシック','sans-serif';}

.title {width: 910px; margin: 1em auto; padding-left: 10px; border-left: 10px solid #9f263c; color: #494949;}
.pricing_table{margin:0 auto; width:1200px; padding: 2em; overflow: hidden;float: left}
.pricing_box {
   border: 1px solid #ccc; float: left;
   text-align: center;
   padding: 0 0 20px 0;
   margin-left:-1px;
   box-shadow: 0 2px 10px -4px rgba(0, 0, 0, 0.5);
   -moz-box-shadow: 0 2px 10px -4px rgba(0, 0, 0, 0.5);
   background: #fff;
}

.pricing_box.radius-left {
    -webkit-border-top-left-radius: 5px;
    border-top-left-radius: 5px;
    -moz-border-top-left-radius: 5px;
    -webkit-border-bottom-left-radius: 5px;
    border-bottom-left-radius: 5px;
    -moz-border-bottom-left-radius: 5px;
}
.pricing_box.radius-left .header {
    -webkit-border-top-left-radius: 5px;
    border-top-left-radius: 5px;
    -moz-border-top-left-radius: 5px;
}

.pricing_box.radius-right {
    -webkit-border-top-right-radius: 5px;
    border-top-right-radius: 5px;
    -moz-border-top-right-radius: 5px;
    -webkit-border-bottom-right-radius: 5px;
    border-bottom-right-radius: 5px;
    -moz-border-bottom-right-radius: 5px;
}

.pricing_box.radius-right .header{
    -webkit-border-top-right-radius: 5px;
    border-top-right-radius: 5px;
    -moz-border-top-right-radius: 5px;
}
.pricing_box .header {
    color:#fff;
    font-size:16px;
    border-bottom:3px solid #ddd;
}

.pricing_box .header { width: 100%; height: 56px; }
.pricing_box .header span { position: relative; top: 16px; font-weight: bold; line-height: 28px;}
.pricing_box .header span.info { position: relative; font-weight: normal; top: 2px; display: block; color: gray; }
.pricing_box p { line-height: 28px;}
.pricing_box ul { list-style: none; margin: 0 0 15px 0!important; text-align: center;padding: 0;}

.pricing_table .pricing_box { width:180px; font-size: 13px;}
.pricing_table .pricing_box .number { font-size: 16px; line-height: 2.45;}
.pricing_table .pricing_box .price { font-size: 20px; height: 70px;}
.pricing_table .pricing_box .price p { margin: 0; display: inline-block; line-height: 1.0; vertical-align: middle; padding-top: 10px;}

.pricing_box ul li { line-height: 3em; margin-left:0; list-style-type: none!important;border-bottom: 1px solid #ddd;}
.pricing_box ul li img { vertical-align: middle; }
.pricing_box strong.no { background-position: 0 0;}
.pricing_box strong.yes { background-position: 0 -15px;}
.pricing_box strong.single { background-position: 0 -30px; }
.pricing_box strong.unlim { background-position: 0 -45px; }

.pricing_box { background: #f8fafb;}
.pricing_box .header{background: #417094;}
.pricing_box ul li { background: #f8fafb;}
.pricing_box .signup a {background: #417094;}
.pricing_box strong.nopad { padding: 0;}
.pricing_box h3{ margin: 20px 0; font-size: 22px; display: block;}
.pricing_box h3 em{ font-size: 12px; font-weight: normal;}

.pricing_box p.button a {
    font-size: 16px;
    height:35px;
    font-weight:bold;
    -webkit-border-top-left-radius:5px;
    -webkit-border-top-right-radius:5px;
    -moz-border-radius:5px 5px 0px 0px;
    border-top-left-radius:5px;
    border-top-right-radius:5px;
    border-bottom-left-radius:5px;
    border-bottom-right-radius:5px;
}

.pricing_box p.button a:hover{
    opacity: 0.8;
}

.pricing_box.large {
    position: relative;
    z-index: 9;
    margin-top: -20px;
    -moz-box-shadow: 0 1px 10px #898989;
    -webkit-box-shadow: 0 1px 10px #898989;
    box-shadow: 0px 1px 10px #898989;
    padding: 0 0 40px 0; border-radius: 5px;
}
.pricing_box.large { font-weight: bold; }
.pricing_box.large .header {
    color:#fff;
    font-size:19px;
    height:75px;
    text-shadow:1px 1px 1px #777;;
    border:1px solid #9fc0ef;
    border-bottom:3px solid #ddd;

    -webkit-border-top-left-radius:5px;
    -webkit-border-top-right-radius:5px;
    -moz-border-radius:5px 5px 0px 0px;
    border-top-left-radius:5px;
    border-top-right-radius:5px;

    background: #b23e53;
}

.pricing_box.large .header  span{ top: 25px; }
.pricing_box.large .header  span.info{ top: 14px; color: #576e1f; text-shadow:none; }

.pricing_box.large p.button a{
    font-size: 16px;
    height:35px;
    font-weight:bold;
    -webkit-border-top-left-radius:5px;
    -webkit-border-top-right-radius:5px;
    -moz-border-radius:5px 5px 0px 0px;
    border-top-left-radius:5px;
    border-top-right-radius:5px;
    border-bottom-left-radius:5px;
    border-bottom-right-radius:5px;
    background: #b23e53;
 }

.pricing_box.large p.button a:hover{
    opacity: 0.8;
}

.pricing_box .space {
    padding-bottom: 28px;
}
.pricing_box .notes {
    padding-left: 1em;
    font-size: 12px;
}
.pricing_box .annual {
    font-size: 12px;
}

.notes-list {
    width: 100%;
    margin: 0 auto;
    list-style-type: none;
    padding: 0;
    float: left;
}

.notes-list li {
    font-size: 12px;
}

/*Buttons*/
p.button { margin: 0 20px 0 0; padding: 0; display: inline-block;}
p.button a{ float: left; line-height:36px; *line-height:28px; margin: 0 -20px 0 0!important; padding: 0 20px; height:100%; border: none; cursor: pointer; color: #fff; font-size: 12px; text-decoration:none }
p.button a:hover{text-decoration: none;}

.graybutton {
    display: inline-block;
    height: 100%;
    line-height: 36px;
    *line-height: 28px;
    color: #FFF;
    text-decoration: none;
    text-align: center;
    background-color: #a4b7c1;
    border-radius: 5px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    margin: 0 0 8px 0!important;
    padding: 0 20px;
    font-size: 16px;
    height: 35px;
    font-weight: bold;
}
.usebutton{
    display: inline-block;
    height: 100%;
    line-height: 36px;
    *line-height: 28px;
    color: #FFF;
    text-decoration: none;
    text-align: center;
    background-color: #B23E53;
    border-radius: 5px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    margin: 0 0 8px 0!important; padding: 0 20px;
    font-size: 16px;
    height: 35px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Grade.vue